module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Db-Fc-Gc-Hb-Ia.43890c2d.png";